import type { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { isWarrantyOnly, WARRANTY_ONLY_HOME } from '../../config/features';

/** Wraps a main-menu screen: when the deployment is Warranty-Lookup-only, its address redirects to Warranty Lookup. */
export function Restricted({ children }: { children: ReactElement }) {
  return isWarrantyOnly() ? <Navigate to={WARRANTY_ONLY_HOME} replace /> : children;
}
